import React, { Component } from "react"
import ErrorPage from "../pages/ErrorPage"
import PropertyDetailsService from "../services/property.details.service"
import { connect } from "react-redux"

class ErrorBoundary extends Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false }
    this.valuationId = props.valuationId
    this.userId = props.userId
  }

  static getDerivedStateFromError(error) {
    return { hasError: true }
  }

  componentDidCatch(error) {
    PropertyDetailsService.reportAppError({
      valuationId: this.valuationId,
      userId: this.userId,
      error: error.toString(),
    })
  }

  render() {
    if (this.state.hasError) {
      return <ErrorPage />
    }

    return this.props.children
  }
}

const mapStateToProps = (state) => ({
  valuationId: state?.valuationsDetails?.currentValuation,
  userId:
    state?.valuationsDetails[state?.valuationsDetails?.currentValuation]
      ?.userProfile?.id,
})

export default connect(mapStateToProps)(ErrorBoundary)
